
import { toast } from "sonner"

export interface AppError {
  code: string
  message: string
  details?: any
  timestamp: Date
  userId?: string
  route?: string
}

class ErrorHandler {
  private static instance: ErrorHandler
  private errors: AppError[] = []

  private constructor() {}

  static getInstance(): ErrorHandler {
    if (!ErrorHandler.instance) {
      ErrorHandler.instance = new ErrorHandler()
    }
    return ErrorHandler.instance
  }

  logError(error: AppError) {
    this.errors.push(error)
    console.error('AppError:', error)
    
    // Enviar para serviço de monitoramento se configurado
    if (process.env.NODE_ENV === 'production') {
      // Aqui você pode integrar com Sentry, LogRocket, etc.
    }
  }

  handleError(error: any, context?: string) {
    const appError: AppError = {
      code: error.code || 'UNKNOWN_ERROR',
      message: error.message || 'Erro desconhecido',
      details: error,
      timestamp: new Date(),
      route: window.location.pathname,
      userId: this.getCurrentUserId()
    }

    this.logError(appError)
    
    // Mostrar toast de erro para o usuário
    toast.error(this.getUserFriendlyMessage(appError.code))
    
    return appError
  }

  private getCurrentUserId(): string | undefined {
    // Implementar lógica para obter ID do usuário atual
    return undefined
  }

  private getUserFriendlyMessage(errorCode: string): string {
    const messages: Record<string, string> = {
      'CONVERSATION_CREATE_ERROR': 'Erro ao criar conversa. Tente novamente.',
      'MESSAGE_SEND_ERROR': 'Erro ao enviar mensagem. Tente novamente.',
      'CONVERSATION_LOAD_ERROR': 'Erro ao carregar conversas. Tente novamente.',
      'USER_LOAD_ERROR': 'Erro ao carregar usuários. Tente novamente.',
      'PERMISSION_DENIED': 'Você não tem permissão para esta ação.',
      'NETWORK_ERROR': 'Erro de conexão. Verifique sua internet.',
      'UNKNOWN_ERROR': 'Erro inesperado. Tente novamente.'
    }
    
    return messages[errorCode] || messages['UNKNOWN_ERROR']
  }

  getErrors(): AppError[] {
    return [...this.errors]
  }

  clearErrors() {
    this.errors = []
  }
}

export const errorHandler = ErrorHandler.getInstance()

// Hook para usar o error handler em componentes React
export const useErrorHandler = () => {
  const handleError = (error: any, context?: string) => {
    return errorHandler.handleError(error, context)
  }

  return { handleError, errors: errorHandler.getErrors() }
}
